export namespace AccountCheckEnum {
  export enum JOIN_CODE {
    UNKNOWN                                = 'UNKNOWN',
    APP_IPHONE_UNKNOWN                     = 'APP_IPHONE_UNKNOWN',
    APP_IPHONE_FACEBOOK                    = 'APP_IPHONE_FACEBOOK',
    APP_IPHONE_TWITTER                     = 'APP_IPHONE_TWITTER',
    APP_IPHONE_APPLE                       = 'APP_IPHONE_APPLE',
    APP_IPHONE_KAKAOTALK                   = 'APP_IPHONE_KAKAOTALK',
    APP_IPHONE_NAVER                       = 'APP_IPHONE_NAVER',

    APP_ANDROID_UNKNOWN                    = 'APP_ANDROID_UNKNOWN',
    APP_ANDROID_FACEBOOK                   = 'APP_ANDROID_FACEBOOK',
    APP_ANDROID_TWITTER                    = 'APP_ANDROID_TWITTER',
    APP_ANDROID_APPLE                      = 'APP_ANDROID_APPLE',
    APP_ANDROID_KAKAOTALK                  = 'APP_ANDROID_KAKAOTALK',
    APP_ANDROID_NAVER                      = 'APP_ANDROID_NAVER',

    APP_ANDROID_TABLET_UNKNOWN             = 'APP_ANDROID_TABLET_UNKNOWN',
    APP_ANDROID_TABLET_FACEBOOK            = 'APP_ANDROID_TABLET_FACEBOOK',
    APP_ANDROID_TABLET_TWITTER             = 'APP_ANDROID_TABLET_TWITTER',
    APP_ANDROID_TABLET_APPLE               = 'APP_ANDROID_TABLET_APPLE',
    APP_ANDROID_TABLET_NAVER               = 'APP_ANDROID_TABLET_NAVER',

    APP_ANDROID_CTN_LG                     = 'APP_ANDROID_CTN_LG',
    APP_ANDROID_CTN_KT                     = 'APP_ANDROID_CTN_KT',

    APP_ANDROID_CTN_HOME_BOY               = 'APP_ANDROID_CTN_HOME_BOY',
    APP_ANDROID_HOME_TABLET                = 'APP_ANDROID_HOME_TABLET',
    APP_ANDROID_HOME_PHONE                 = 'APP_ANDROID_HOME_PHONE',

    PC_WEB_UNKNOWN                         = 'PC_WEB_UNKNOWN',
    PC_WEB_FACEBOOK                        = 'PC_WEB_FACEBOOK',
    PC_WEB_TWITTER                         = 'PC_WEB_TWITTER',
    PC_WEB_APPLE                           = 'PC_WEB_APPLE',
    PC_WEB_KAKAOTALK                       = 'PC_WEB_KAKAOTALK',
    PC_WEB_NAVER                           = 'PC_WEB_NAVER',

    MOBILE_WEB_UNKNOWN                     = 'MOBILE_WEB_UNKNOWN',
    MOBILE_WEB_FACEBOOK                    = 'MOBILE_WEB_FACEBOOK',
    MOBILE_WEB_TWITTER                     = 'MOBILE_WEB_TWITTER',
    MOBILE_WEB_APPLE                       = 'MOBILE_WEB_APPLE',
    MOBILE_WEB_KAKAOTALK                   = 'MOBILE_WEB_KAKAOTALK',
    MOBILE_WEB_NAVER                       = 'MOBILE_WEB_NAVER',
    MOBILE_WEB_TV_OLLEH                    = 'MOBILE_WEB_TV_OLLEH',
    MOBILE_WEB_TV_U_PLUS                   = 'MOBILE_WEB_TV_U_PLUS',

    MOBILE_WEB_OPEN_API                    = 'MOBILE_WEB_OPEN_API',

    APP_IPHONE_GIGA_GBOX_UNKNOWN           = 'APP_IPHONE_GIGA_GBOX_UNKNOWN',
    APP_IPHONE_GIGA_GBOX_FACEBOOK          = 'APP_IPHONE_GIGA_GBOX_FACEBOOK',
    APP_IPHONE_GIGA_GBOX_TWITTER           = 'APP_IPHONE_GIGA_GBOX_TWITTER',
    APP_IPHONE_GIGA_GBOX_APPLE             = 'APP_IPHONE_GIGA_GBOX_APPLE',
    APP_IPHONE_GIGA_GBOX_KAKAOTALK         = 'APP_IPHONE_GIGA_GBOX_KAKAOTALK',
    APP_IPHONE_GIGA_GBOX2_UNKNOWN          = 'APP_IPHONE_GIGA_GBOX2_UNKNOWN',
    APP_IPHONE_GIGA_GBOX2_FACEBOOK         = 'APP_IPHONE_GIGA_GBOX2_FACEBOOK',
    APP_IPHONE_GIGA_GBOX2_TWITTER          = 'APP_IPHONE_GIGA_GBOX2_TWITTER',
    APP_IPHONE_GIGA_GBOX2_APPLE            = 'APP_IPHONE_GIGA_GBOX2_APPLE',
    APP_IPHONE_GIGA_GBOX2_KAKAOTALK        = 'APP_IPHONE_GIGA_GBOX2_KAKAOTALK',

    APP_IPHONE_GIGA_GBOX3_UNKNOWN          = 'APP_IPHONE_GIGA_GBOX3_UNKNOWN',
    APP_IPHONE_GIGA_GBOX3_FACEBOOK         = 'APP_IPHONE_GIGA_GBOX3_FACEBOOK',
    APP_IPHONE_GIGA_GBOX3_TWITTER          = 'APP_IPHONE_GIGA_GBOX3_TWITTER',
    APP_IPHONE_GIGA_GBOX3_APPLE            = 'APP_IPHONE_GIGA_GBOX3_APPLE',
    APP_IPHONE_GIGA_GBOX3_KAKAOTALK        = 'APP_IPHONE_GIGA_GBOX3_KAKAOTALK',

    APP_IPHONE_GIGA_LTE_UNKNOWN            = 'APP_IPHONE_GIGA_LTE_UNKNOWN',
    APP_IPHONE_GIGA_LTE_FACEBOOK           = 'APP_IPHONE_GIGA_LTE_FACEBOOK',
    APP_IPHONE_GIGA_LTE_TWITTER            = 'APP_IPHONE_GIGA_LTE_TWITTER',
    APP_IPHONE_GIGA_LTE_APPLE              = 'APP_IPHONE_GIGA_LTE_APPLE',
    APP_IPHONE_GIGA_LTE_KAKAOTALK          = 'APP_IPHONE_GIGA_LTE_KAKAOTALK',

    APP_IPHONE_GIGA_LTE2_UNKNOWN           = 'APP_IPHONE_GIGA_LTE2_UNKNOWN',
    APP_IPHONE_GIGA_LTE2_FACEBOOK          = 'APP_IPHONE_GIGA_LTE2_FACEBOOK',
    APP_IPHONE_GIGA_LTE2_TWITTER           = 'APP_IPHONE_GIGA_LTE2_TWITTER',
    APP_IPHONE_GIGA_LTE2_APPLE             = 'APP_IPHONE_GIGA_LTE2_APPLE',
    APP_IPHONE_GIGA_LTE2_KAKAOTALK         = 'APP_IPHONE_GIGA_LTE2_KAKAOTALK',

    APP_IPHONE_GIGA_TABLE_TV_UNKNOWN       = 'APP_IPHONE_GIGA_TABLE_TV_UNKNOWN',
    APP_IPHONE_GIGA_TABLE_TV_FACEBOOK      = 'APP_IPHONE_GIGA_TABLE_TV_FACEBOOK',
    APP_IPHONE_GIGA_TABLE_TV_TWITTER       = 'APP_IPHONE_GIGA_TABLE_TV_TWITTER',
    APP_IPHONE_GIGA_TABLE_TV_APPLE         = 'APP_IPHONE_GIGA_TABLE_TV_APPLE',
    APP_IPHONE_GIGA_TABLE_TV_KAKAOTALK     = 'APP_IPHONE_GIGA_TABLE_TV_KAKAOTALK',

    APP_IPHONE_GIGA_TABLE_TV2_UNKNOWN      = 'APP_IPHONE_GIGA_TABLE_TV2_UNKNOWN',
    APP_IPHONE_GIGA_TABLE_TV2_FACEBOOK     = 'APP_IPHONE_GIGA_TABLE_TV2_FACEBOOK',
    APP_IPHONE_GIGA_TABLE_TV2_TWITTER      = 'APP_IPHONE_GIGA_TABLE_TV2_TWITTER',
    APP_IPHONE_GIGA_TABLE_TV2_APPLE        = 'APP_IPHONE_GIGA_TABLE_TV2_APPLE',
    APP_IPHONE_GIGA_TABLE_TV2_KAKAOTALK    = 'APP_IPHONE_GIGA_TABLE_TV2_KAKAOTALK',

    APP_IPHONE_GIGA_BUDDY_UNKNOWN          = 'APP_IPHONE_GIGA_BUDDY_UNKNOWN',
    APP_IPHONE_GIGA_BUDDY_FACEBOOK         = 'APP_IPHONE_GIGA_BUDDY_FACEBOOK',
    APP_IPHONE_GIGA_BUDDY_TWITTER          = 'APP_IPHONE_GIGA_BUDDY_TWITTER',
    APP_IPHONE_GIGA_BUDDY_APPLE            = 'APP_IPHONE_GIGA_BUDDY_APPLE',
    APP_IPHONE_GIGA_BUDDY_KAKAOTALK        = 'APP_IPHONE_GIGA_BUDDY_KAKAOTALK',

    APP_IPHONE_GIGA_SKYLIFE_UNKNOWN        = 'APP_IPHONE_GIGA_SKYLIFE_UNKNOWN',
    APP_IPHONE_GIGA_SKYLIFE_FACEBOOK       = 'APP_IPHONE_GIGA_SKYLIFE_FACEBOOK',
    APP_IPHONE_GIGA_SKYLIFE_TWITTER        = 'APP_IPHONE_GIGA_SKYLIFE_TWITTER',
    APP_IPHONE_GIGA_SKYLIFE_APPLE          = 'APP_IPHONE_GIGA_SKYLIFE_APPLE',
    APP_IPHONE_GIGA_SKYLIFE_KAKAOTALK      = 'APP_IPHONE_GIGA_SKYLIFE_KAKAOTALK',

    APP_IPHONE_GIGA_ATV_UNKNOWN            = 'APP_IPHONE_GIGA_ATV_UNKNOWN',
    APP_IPHONE_GIGA_ATV_FACEBOOK           = 'APP_IPHONE_GIGA_ATV_FACEBOOK',
    APP_IPHONE_GIGA_ATV_TWITTER            = 'APP_IPHONE_GIGA_ATV_TWITTER',
    APP_IPHONE_GIGA_ATV_APPLE              = 'APP_IPHONE_GIGA_ATV_APPLE',
    APP_IPHONE_GIGA_ATV_KAKAOTALK          = 'APP_IPHONE_GIGA_ATV_KAKAOTALK',

    APP_ANDROID_GIGA_GBOX_UNKNOWN          = 'APP_ANDROID_GIGA_GBOX_UNKNOWN',
    APP_ANDROID_GIGA_GBOX_FACEBOOK         = 'APP_ANDROID_GIGA_GBOX_FACEBOOK',
    APP_ANDROID_GIGA_GBOX_TWITTER          = 'APP_ANDROID_GIGA_GBOX_TWITTER',
    APP_ANDROID_GIGA_GBOX_APPLE            = 'APP_ANDROID_GIGA_GBOX_APPLE',
    APP_ANDROID_GIGA_GBOX_KAKAOTALK        = 'APP_ANDROID_GIGA_GBOX_KAKAOTALK',
    APP_ANDROID_GIGA_GBOX_CTN_LG           = 'APP_ANDROID_GIGA_GBOX_CTN_LG',
    APP_ANDROID_GIGA_GBOX_CTN_KT           = 'APP_ANDROID_GIGA_GBOX_CTN_KT',

    APP_ANDROID_GIGA_GBOX2_UNKNOWN         = 'APP_ANDROID_GIGA_GBOX2_UNKNOWN',
    APP_ANDROID_GIGA_GBOX2_FACEBOOK        = 'APP_ANDROID_GIGA_GBOX2_FACEBOOK',
    APP_ANDROID_GIGA_GBOX2_TWITTER         = 'APP_ANDROID_GIGA_GBOX2_TWITTER',
    APP_ANDROID_GIGA_GBOX2_APPLE           = 'APP_ANDROID_GIGA_GBOX2_APPLE',
    APP_ANDROID_GIGA_GBOX2_KAKAOTALK       = 'APP_ANDROID_GIGA_GBOX2_KAKAOTALK',
    APP_ANDROID_GIGA_GBOX2_CTN_LG          = 'APP_ANDROID_GIGA_GBOX2_CTN_LG',
    APP_ANDROID_GIGA_GBOX2_CTN_KT          = 'APP_ANDROID_GIGA_GBOX2_CTN_KT',

    APP_ANDROID_GIGA_GBOX3_UNKNOWN         = 'APP_ANDROID_GIGA_GBOX3_UNKNOWN',
    APP_ANDROID_GIGA_GBOX3_FACEBOOK        = 'APP_ANDROID_GIGA_GBOX3_FACEBOOK',
    APP_ANDROID_GIGA_GBOX3_TWITTER         = 'APP_ANDROID_GIGA_GBOX3_TWITTER',
    APP_ANDROID_GIGA_GBOX3_APPLE           = 'APP_ANDROID_GIGA_GBOX3_APPLE',
    APP_ANDROID_GIGA_GBOX3_KAKAOTALK       = 'APP_ANDROID_GIGA_GBOX3_KAKAOTALK',
    APP_ANDROID_GIGA_GBOX3_CTN_LG          = 'APP_ANDROID_GIGA_GBOX3_CTN_LG',
    APP_ANDROID_GIGA_GBOX3_CTN_KT          = 'APP_ANDROID_GIGA_GBOX3_CTN_KT',

    APP_ANDROID_GIGA_LTE_UNKNOWN           = 'APP_ANDROID_GIGA_LTE_UNKNOWN',
    APP_ANDROID_GIGA_LTE_FACEBOOK          = 'APP_ANDROID_GIGA_LTE_FACEBOOK',
    APP_ANDROID_GIGA_LTE_TWITTER           = 'APP_ANDROID_GIGA_LTE_TWITTER',
    APP_ANDROID_GIGA_LTE_APPLE             = 'APP_ANDROID_GIGA_LTE_APPLE',
    APP_ANDROID_GIGA_LTE_KAKAOTALK         = 'APP_ANDROID_GIGA_LTE_KAKAOTALK',
    APP_ANDROID_GIGA_LTE_CTN_LG            = 'APP_ANDROID_GIGA_LTE_CTN_LG',
    APP_ANDROID_GIGA_LTE_CTN_KT            = 'APP_ANDROID_GIGA_LTE_CTN_KT',

    APP_ANDROID_GIGA_LTE2_UNKNOWN          = 'APP_ANDROID_GIGA_LTE2_UNKNOWN',
    APP_ANDROID_GIGA_LTE2_FACEBOOK         = 'APP_ANDROID_GIGA_LTE2_FACEBOOK',
    APP_ANDROID_GIGA_LTE2_TWITTER          = 'APP_ANDROID_GIGA_LTE2_TWITTER',
    APP_ANDROID_GIGA_LTE2_APPLE            = 'APP_ANDROID_GIGA_LTE2_APPLE',
    APP_ANDROID_GIGA_LTE2_KAKAOTALK        = 'APP_ANDROID_GIGA_LTE2_KAKAOTALK',
    APP_ANDROID_GIGA_LTE2_CTN_LG           = 'APP_ANDROID_GIGA_LTE2_CTN_LG',
    APP_ANDROID_GIGA_LTE2_CTN_KT           = 'APP_ANDROID_GIGA_LTE2_CTN_KT',

    APP_ANDROID_GIGA_TABLE_TV_UNKNOWN      = 'APP_ANDROID_GIGA_TABLE_TV_UNKNOWN',
    APP_ANDROID_GIGA_TABLE_TV_FACEBOOK     = 'APP_ANDROID_GIGA_TABLE_TV_FACEBOOK',
    APP_ANDROID_GIGA_TABLE_TV_TWITTER      = 'APP_ANDROID_GIGA_TABLE_TV_TWITTER',
    APP_ANDROID_GIGA_TABLE_TV_APPLE        = 'APP_ANDROID_GIGA_TABLE_TV_APPLE',
    APP_ANDROID_GIGA_TABLE_TV_KAKAOTALK    = 'APP_ANDROID_GIGA_TABLE_TV_KAKAOTALK',
    APP_ANDROID_GIGA_TABLE_TV_CTN_LG       = 'APP_ANDROID_GIGA_TABLE_TV_CTN_LG',
    APP_ANDROID_GIGA_TABLE_TV_CTN_KT       = 'APP_ANDROID_GIGA_TABLE_TV_CTN_KT',

    APP_ANDROID_GIGA_TABLE_TV2_UNKNOWN     = 'APP_ANDROID_GIGA_TABLE_TV2_UNKNOWN',
    APP_ANDROID_GIGA_TABLE_TV2_FACEBOOK    = 'APP_ANDROID_GIGA_TABLE_TV2_FACEBOOK',
    APP_ANDROID_GIGA_TABLE_TV2_TWITTER     = 'APP_ANDROID_GIGA_TABLE_TV2_TWITTER',
    APP_ANDROID_GIGA_TABLE_TV2_APPLE       = 'APP_ANDROID_GIGA_TABLE_TV2_APPLE',
    APP_ANDROID_GIGA_TABLE_TV2_KAKAOTALK   = 'APP_ANDROID_GIGA_TABLE_TV2_KAKAOTALK',
    APP_ANDROID_GIGA_TABLE_TV2_CTN_LG      = 'APP_ANDROID_GIGA_TABLE_TV2_CTN_LG',
    APP_ANDROID_GIGA_TABLE_TV2_CTN_KT      = 'APP_ANDROID_GIGA_TABLE_TV2_CTN_KT',

    APP_ANDROID_GIGA_BUDDY_UNKNOWN         = 'APP_ANDROID_GIGA_BUDDY_UNKNOWN',
    APP_ANDROID_GIGA_BUDDY_FACEBOOK        = 'APP_ANDROID_GIGA_BUDDY_FACEBOOK',
    APP_ANDROID_GIGA_BUDDY_TWITTER         = 'APP_ANDROID_GIGA_BUDDY_TWITTER',
    APP_ANDROID_GIGA_BUDDY_APPLE           = 'APP_ANDROID_GIGA_BUDDY_APPLE',
    APP_ANDROID_GIGA_BUDDY_KAKAOTALK       = 'APP_ANDROID_GIGA_BUDDY_KAKAOTALK',
    APP_ANDROID_GIGA_BUDDY_CTN_LG          = 'APP_ANDROID_GIGA_BUDDY_CTN_LG',
    APP_ANDROID_GIGA_BUDDY_CTN_KT          = 'APP_ANDROID_GIGA_BUDDY_CTN_KT',

    APP_ANDROID_GIGA_SKYLIFE_UNKNOWN       = 'APP_ANDROID_GIGA_SKYLIFE_UNKNOWN',
    APP_ANDROID_GIGA_SKYLIFE_FACEBOOK      = 'APP_ANDROID_GIGA_SKYLIFE_FACEBOOK',
    APP_ANDROID_GIGA_SKYLIFE_TWITTER       = 'APP_ANDROID_GIGA_SKYLIFE_TWITTER',
    APP_ANDROID_GIGA_SKYLIFE_APPLE         = 'APP_ANDROID_GIGA_SKYLIFE_APPLE',
    APP_ANDROID_GIGA_SKYLIFE_KAKAOTALK     = 'APP_ANDROID_GIGA_SKYLIFE_KAKAOTALK',
    APP_ANDROID_GIGA_SKYLIFE_CTN_LG        = 'APP_ANDROID_GIGA_SKYLIFE_CTN_LG',
    APP_ANDROID_GIGA_SKYLIFE_CTN_KT        = 'APP_ANDROID_GIGA_SKYLIFE_CTN_KT',

    APP_ANDROID_GIGA_ATV_UNKNOWN           = 'APP_ANDROID_GIGA_ATV_UNKNOWN',
    APP_ANDROID_GIGA_ATV_FACEBOOK          = 'APP_ANDROID_GIGA_ATV_FACEBOOK',
    APP_ANDROID_GIGA_ATV_TWITTER           = 'APP_ANDROID_GIGA_ATV_TWITTER',
    APP_ANDROID_GIGA_ATV_APPLE             = 'APP_ANDROID_GIGA_ATV_APPLE',
    APP_ANDROID_GIGA_ATV_KAKAOTALK         = 'APP_ANDROID_GIGA_ATV_KAKAOTALK',
    APP_ANDROID_GIGA_ATV_CTN_LG            = 'APP_ANDROID_GIGA_ATV_CTN_LG',
    APP_ANDROID_GIGA_ATV_CTN_KT            = 'APP_ANDROID_GIGA_ATV_CTN_KT',

    APP_IPHONE_OPEN_API                    = 'APP_IPHONE_OPEN_API',

    APP_IPHONE_GIGA_GBOX_NAVER             = 'APP_IPHONE_GIGA_GBOX_NAVER',
    APP_IPHONE_GIGA_GBOX2_NAVER            = 'APP_IPHONE_GIGA_GBOX2_NAVER',
    APP_IPHONE_GIGA_GBOX3_NAVER            = 'APP_IPHONE_GIGA_GBOX3_NAVER',
    APP_IPHONE_GIGA_LTE_NAVER              = 'APP_IPHONE_GIGA_LTE_NAVER',
    APP_IPHONE_GIGA_LTE2_NAVER             = 'APP_IPHONE_GIGA_LTE2_NAVER',
    APP_IPHONE_GIGA_TABLE_TV_NAVER         = 'APP_IPHONE_GIGA_TABLE_TV_NAVER',
    APP_IPHONE_GIGA_TABLE_TV2_NAVER        = 'APP_IPHONE_GIGA_TABLE_TV2_NAVER',
    APP_IPHONE_GIGA_BUDDY_NAVER            = 'APP_IPHONE_GIGA_BUDDY_NAVER',
    APP_IPHONE_GIGA_SKYLIFE_NAVER          = 'APP_IPHONE_GIGA_SKYLIFE_NAVER',
    APP_IPHONE_GIGA_ATV_NAVER              = 'APP_IPHONE_GIGA_ATV_NAVER',
    APP_IPHONE_GIGA_SOUND_BAR_UNKNOWN      = 'APP_IPHONE_GIGA_SOUND_BAR_UNKNOWN',
    APP_IPHONE_GIGA_SOUND_BAR_FACEBOOK     = 'APP_IPHONE_GIGA_SOUND_BAR_FACEBOOK',
    APP_IPHONE_GIGA_SOUND_BAR_TWITTER      = 'APP_IPHONE_GIGA_SOUND_BAR_TWITTER',
    APP_IPHONE_GIGA_SOUND_BAR_APPLE        = 'APP_IPHONE_GIGA_SOUND_BAR_APPLE',
    APP_IPHONE_GIGA_SOUND_BAR_KAKAOTALK    = 'APP_IPHONE_GIGA_SOUND_BAR_KAKAOTALK',
    APP_IPHONE_GIGA_SOUND_BAR_NAVER        = 'APP_IPHONE_GIGA_SOUND_BAR_NAVER',

    APP_ANDROID_OPEN_API                   = 'APP_ANDROID_OPEN_API',

    APP_ANDROID_GIGA_GBOX_NAVER            = 'APP_ANDROID_GIGA_GBOX_NAVER',
    APP_ANDROID_GIGA_GBOX2_NAVER           = 'APP_ANDROID_GIGA_GBOX2_NAVER',
    APP_ANDROID_GIGA_GBOX3_NAVER           = 'APP_ANDROID_GIGA_GBOX3_NAVER',
    APP_ANDROID_GIGA_LTE_NAVER             = 'APP_ANDROID_GIGA_LTE_NAVER',
    APP_ANDROID_GIGA_LTE2_NAVER            = 'APP_ANDROID_GIGA_LTE2_NAVER',
    APP_ANDROID_GIGA_TABLE_TV_NAVER        = 'APP_ANDROID_GIGA_TABLE_TV_NAVER',
    APP_ANDROID_GIGA_TABLE_TV2_NAVER       = 'APP_ANDROID_GIGA_TABLE_TV2_NAVER',
    APP_ANDROID_GIGA_BUDDY_NAVER           = 'APP_ANDROID_GIGA_BUDDY_NAVER',
    APP_ANDROID_GIGA_SKYLIFE_NAVER         = 'APP_ANDROID_GIGA_SKYLIFE_NAVER',
    APP_ANDROID_GIGA_ATV_NAVER             = 'APP_ANDROID_GIGA_ATV_NAVER',
    APP_ANDROID_GIGA_SOUND_BAR_UNKNOWN     = 'APP_ANDROID_GIGA_SOUND_BAR_UNKNOWN',
    APP_ANDROID_GIGA_SOUND_BAR_FACEBOOK    = 'APP_ANDROID_GIGA_SOUND_BAR_FACEBOOK',
    APP_ANDROID_GIGA_SOUND_BAR_TWITTER     = 'APP_ANDROID_GIGA_SOUND_BAR_TWITTER',
    APP_ANDROID_GIGA_SOUND_BAR_APPLE       = 'APP_ANDROID_GIGA_SOUND_BAR_APPLE',
    APP_ANDROID_GIGA_SOUND_BAR_KAKAOTALK   = 'APP_ANDROID_GIGA_SOUND_BAR_KAKAOTALK',
    APP_ANDROID_GIGA_SOUND_BAR_NAVER       = 'APP_ANDROID_GIGA_SOUND_BAR_NAVER',
    APP_ANDROID_GIGA_SOUND_BAR_CTN_LG      = 'APP_ANDROID_GIGA_SOUND_BAR_CTN_LG',
    APP_ANDROID_GIGA_SOUND_BAR_CTN_KT      = 'APP_ANDROID_GIGA_SOUND_BAR_CTN_KT',

    APP_IPHONE_GIGA_GBOX2_ATV_UNKNOWN      = 'APP_IPHONE_GIGA_GBOX2_ATV_UNKNOWN',
    APP_IPHONE_GIGA_GBOX2_ATV_FACEBOOK     = 'APP_IPHONE_GIGA_GBOX2_ATV_FACEBOOK',
    APP_IPHONE_GIGA_GBOX2_ATV_TWITTER      = 'APP_IPHONE_GIGA_GBOX2_ATV_TWITTER',
    APP_IPHONE_GIGA_GBOX2_ATV_APPLE        = 'APP_IPHONE_GIGA_GBOX2_ATV_APPLE',
    APP_IPHONE_GIGA_GBOX2_ATV_KAKAOTALK    = 'APP_IPHONE_GIGA_GBOX2_ATV_KAKAOTALK',
    APP_IPHONE_GIGA_GBOX2_ATV_NAVER        = 'APP_IPHONE_GIGA_GBOX2_ATV_NAVER',

    APP_IPHONE_GIGA_GBOX3_ATV_UNKNOWN      = 'APP_IPHONE_GIGA_GBOX3_ATV_UNKNOWN',
    APP_IPHONE_GIGA_GBOX3_ATV_FACEBOOK     = 'APP_IPHONE_GIGA_GBOX3_ATV_FACEBOOK',
    APP_IPHONE_GIGA_GBOX3_ATV_TWITTER      = 'APP_IPHONE_GIGA_GBOX3_ATV_TWITTER',
    APP_IPHONE_GIGA_GBOX3_ATV_APPLE        = 'APP_IPHONE_GIGA_GBOX3_ATV_APPLE',
    APP_IPHONE_GIGA_GBOX3_ATV_KAKAOTALK    = 'APP_IPHONE_GIGA_GBOX3_ATV_KAKAOTALK',
    APP_IPHONE_GIGA_GBOX3_ATV_NAVER        = 'APP_IPHONE_GIGA_GBOX3_ATV_NAVER',

    APP_ANDROID_GIGA_GBOX2_ATV_UNKNOWN     = 'APP_ANDROID_GIGA_GBOX2_ATV_UNKNOWN',
    APP_ANDROID_GIGA_GBOX2_ATV_FACEBOOK    = 'APP_ANDROID_GIGA_GBOX2_ATV_FACEBOOK',
    APP_ANDROID_GIGA_GBOX2_ATV_TWITTER     = 'APP_ANDROID_GIGA_GBOX2_ATV_TWITTER',
    APP_ANDROID_GIGA_GBOX2_ATV_APPLE       = 'APP_ANDROID_GIGA_GBOX2_ATV_APPLE',
    APP_ANDROID_GIGA_GBOX2_ATV_KAKAOTALK   = 'APP_ANDROID_GIGA_GBOX2_ATV_KAKAOTALK',
    APP_ANDROID_GIGA_GBOX2_ATV_NAVER       = 'APP_ANDROID_GIGA_GBOX2_ATV_NAVER',
    APP_ANDROID_GIGA_GBOX2_ATV_CTN_LG      = 'APP_ANDROID_GIGA_GBOX2_ATV_CTN_LG',
    APP_ANDROID_GIGA_GBOX2_ATV_CTN_KT      = 'APP_ANDROID_GIGA_GBOX2_ATV_CTN_KT',

    APP_ANDROID_GIGA_GBOX3_ATV_UNKNOWN     = 'APP_ANDROID_GIGA_GBOX3_ATV_UNKNOWN',
    APP_ANDROID_GIGA_GBOX3_ATV_FACEBOOK    = 'APP_ANDROID_GIGA_GBOX3_ATV_FACEBOOK',
    APP_ANDROID_GIGA_GBOX3_ATV_TWITTER     = 'APP_ANDROID_GIGA_GBOX3_ATV_TWITTER',
    APP_ANDROID_GIGA_GBOX3_ATV_APPLE       = 'APP_ANDROID_GIGA_GBOX3_ATV_APPLE',
    APP_ANDROID_GIGA_GBOX3_ATV_KAKAOTALK   = 'APP_ANDROID_GIGA_GBOX3_ATV_KAKAOTALK',
    APP_ANDROID_GIGA_GBOX3_ATV_NAVER       = 'APP_ANDROID_GIGA_GBOX3_ATV_NAVER',
    APP_ANDROID_GIGA_GBOX3_ATV_CTN_LG      = 'APP_ANDROID_GIGA_GBOX3_ATV_CTN_LG',
    APP_ANDROID_GIGA_GBOX3_ATV_CTN_KT      = 'APP_ANDROID_GIGA_GBOX3_ATV_CTN_KT',

    APP_IPHONE_GIGA_GBOX4_UNKNOWN          = 'APP_IPHONE_GIGA_GBOX4_UNKNOWN',
    APP_ANDROID_GIGA_GBOX4_UNKNOWN         = 'APP_ANDROID_GIGA_GBOX4_UNKNOWN',
    APP_IPHONE_GIGA_GBOX4_FACEBOOK         = 'APP_IPHONE_GIGA_GBOX4_FACEBOOK',
    APP_ANDROID_GIGA_GBOX4_FACEBOOK        = 'APP_ANDROID_GIGA_GBOX4_FACEBOOK',
    APP_IPHONE_GIGA_GBOX4_TWITTER          = 'APP_IPHONE_GIGA_GBOX4_TWITTER',
    APP_ANDROID_GIGA_GBOX4_TWITTER         = 'APP_ANDROID_GIGA_GBOX4_TWITTER',
    APP_IPHONE_GIGA_GBOX4_KAKAOTALK        = 'APP_IPHONE_GIGA_GBOX4_KAKAOTALK',
    APP_ANDROID_GIGA_GBOX4_KAKAOTALK       = 'APP_ANDROID_GIGA_GBOX4_KAKAOTALK',
    APP_IPHONE_GIGA_GBOX4_APPLE            = 'APP_IPHONE_GIGA_GBOX4_APPLE',
    APP_ANDROID_GIGA_GBOX4_APPLE           = 'APP_ANDROID_GIGA_GBOX4_APPLE',
    APP_ANDROID_GIGA_GBOX4_CTN_KT          = 'APP_ANDROID_GIGA_GBOX4_CTN_KT',
    APP_ANDROID_GIGA_GBOX4_CTN_LG          = 'APP_ANDROID_GIGA_GBOX4_CTN_LG',
    APP_IPHONE_GIGA_GBOX4_NAVER            = 'APP_IPHONE_GIGA_GBOX4_NAVER',
    APP_ANDROID_GIGA_GBOX4_NAVER           = 'APP_ANDROID_GIGA_GBOX4_NAVER',

    APP_IPHONE_GIGA_SKYLIFE_TV_UNKNOWN     = 'APP_IPHONE_GIGA_SKYLIFE_TV_UNKNOWN',
    APP_IPHONE_GIGA_SKYLIFE_TV_FACEBOOK    = 'APP_IPHONE_GIGA_SKYLIFE_TV_FACEBOOK',
    APP_IPHONE_GIGA_SKYLIFE_TV_KAKAOTALK   = 'APP_IPHONE_GIGA_SKYLIFE_TV_KAKAOTALK',
    APP_IPHONE_GIGA_SKYLIFE_TV_APPLE       = 'APP_IPHONE_GIGA_SKYLIFE_TV_APPLE',
    APP_IPHONE_GIGA_SKYLIFE_TV_NAVER       = 'APP_IPHONE_GIGA_SKYLIFE_TV_NAVER',
    APP_IPHONE_GIGA_HCN_TV_UNKNOWN         = 'APP_IPHONE_GIGA_HCN_TV_UNKNOWN',
    APP_IPHONE_GIGA_HCN_TV_FACEBOOK        = 'APP_IPHONE_GIGA_HCN_TV_FACEBOOK',
    APP_IPHONE_GIGA_HCN_TV_KAKAOTALK       = 'APP_IPHONE_GIGA_HCN_TV_KAKAOTALK',
    APP_IPHONE_GIGA_HCN_TV_APPLE           = 'APP_IPHONE_GIGA_HCN_TV_APPLE',
    APP_IPHONE_GIGA_HCN_TV_NAVER           = 'APP_IPHONE_GIGA_HCN_TV_NAVER',
    APP_ANDROID_GIGA_SKYLIFE_TV_UNKNOWN    = 'APP_ANDROID_GIGA_SKYLIFE_TV_UNKNOWN',
    APP_ANDROID_GIGA_SKYLIFE_TV_FACEBOOK   = 'APP_ANDROID_GIGA_SKYLIFE_TV_FACEBOOK',
    APP_ANDROID_GIGA_SKYLIFE_TV_APPLE      = 'APP_ANDROID_GIGA_SKYLIFE_TV_APPLE',
    APP_ANDROID_GIGA_SKYLIFE_TV_KAKAOTALK  = 'APP_ANDROID_GIGA_SKYLIFE_TV_KAKAOTALK',
    APP_ANDROID_GIGA_SKYLIFE_TV_NAVER      = 'APP_ANDROID_GIGA_SKYLIFE_TV_NAVER',
    APP_ANDROID_GIGA_SKYLIFE_TV_CTN_LG     = 'APP_ANDROID_GIGA_SKYLIFE_TV_CTN_LG',
    APP_ANDROID_GIGA_SKYLIFE_TV_CTN_KT     = 'APP_ANDROID_GIGA_SKYLIFE_TV_CTN_KT',
    APP_ANDROID_GIGA_HCN_TV_UNKNOWN        = 'APP_ANDROID_GIGA_HCN_TV_UNKNOWN',
    APP_ANDROID_GIGA_HCN_TV_FACEBOOK       = 'APP_ANDROID_GIGA_HCN_TV_FACEBOOK',
    APP_ANDROID_GIGA_HCN_TV_APPLE          = 'APP_ANDROID_GIGA_HCN_TV_APPLE',
    APP_ANDROID_GIGA_HCN_TV_KAKAOTALK      = 'APP_ANDROID_GIGA_HCN_TV_KAKAOTALK',
    APP_ANDROID_GIGA_HCN_TV_NAVER          = 'APP_ANDROID_GIGA_HCN_TV_NAVER',
    APP_ANDROID_GIGA_HCN_TV_CTN_LG         = 'APP_ANDROID_GIGA_HCN_TV_CTN_LG',
    APP_ANDROID_GIGA_HCN_TV_CTN_KT         = 'APP_ANDROID_GIGA_HCN_TV_CTN_KT',

    APP_ANDROID_AUTO_UNKNOWN               = 'APP_ANDROID_AUTO_UNKNOWN',
    APP_ANDROID_AUTO_FACEBOOK              = 'APP_ANDROID_AUTO_FACEBOOK',
    APP_ANDROID_AUTO_KAKAOTALK             = 'APP_ANDROID_AUTO_KAKAOTALK',
    APP_ANDROID_AUTO_APPLE                 = 'APP_ANDROID_AUTO_APPLE',
    APP_ANDROID_AUTO_NAVER                 = 'APP_ANDROID_AUTO_NAVER',
    APP_ANDROID_AUTO_CTN_KT                = 'APP_ANDROID_AUTO_CTN_KT',
    APP_ANDROID_AUTO_CTN_LG                = 'APP_ANDROID_AUTO_CTN_LG',
    APP_IPHONE_CARPALY_UNKNOWN             = 'APP_IPHONE_CARPALY_UNKNOWN',
    APP_IPHONE_CARPALY_FACEBOOK            = 'APP_IPHONE_CARPALY_FACEBOOK',
    APP_IPHONE_CARPALY_KAKAOTALK           = 'APP_IPHONE_CARPALY_KAKAOTALK',
    APP_IPHONE_CARPALY_APPLE               = 'APP_IPHONE_CARPALY_APPLE',
    APP_IPHONE_CARPALY_NAVER               = 'APP_IPHONE_CARPALY_NAVER',
    MOBILE_WEB_AUTOMOTIVE_UNKNOWN          = 'MOBILE_WEB_AUTOMOTIVE_UNKNOWN',
    MOBILE_WEB_AUTOMOTIVE_FACEBOOK         = 'MOBILE_WEB_AUTOMOTIVE_FACEBOOK',
    MOBILE_WEB_AUTOMOTIVE_KAKAOTALK        = 'MOBILE_WEB_AUTOMOTIVE_KAKAOTALK',
    MOBILE_WEB_AUTOMOTIVE_APPLE            = 'MOBILE_WEB_AUTOMOTIVE_APPLE',
    MOBILE_WEB_AUTOMOTIVE_NAVER            = 'MOBILE_WEB_AUTOMOTIVE_NAVER',
    MOBILE_WEB_AUTOMOTIVE_CTN_KT           = 'MOBILE_WEB_AUTOMOTIVE_CTN_KT',
    MOBILE_WEB_AUTOMOTIVE_CTN_LG           = 'MOBILE_WEB_AUTOMOTIVE_CTN_LG'
  }

  export enum TARGET_TYPE {
    PC = 'PC',
    MOBILE = 'MOBILE',
    APP = 'APP',
    CTN = 'CTN',
    GIGA = 'GIGA',
    GIGA_CTN = 'GIGA_CTN',
    OPEN_API = 'OPEN_API',
  }

  export enum ACTION_TYPE {
    CREATE = 'CREATE',
    FIND_ID = 'FIND_ID',
    FIND_PW = 'FIND_PW'
  }

  export enum PLATFORM_CODE {
    IOS = 'IOS',
    ANDROID = 'ANDROID',
    PC_WEB = 'PC_WEB',
    MOBILE_WEB = 'MOBILE_WEB'
  }

  export enum RESULT_FLAG {
    CREATE_RESULT = 'CREATE_RESULT',
    FIND_IDENTIFIER_RESULT = 'FIND_IDENTIFIER_RESULT',
    FIND_PASSWORD_RESULT = 'FIND_PASSWORD_RESULT',
    CHANGE_PASSWORD_RESULT = 'CHANGE_PASSWORD_RESULT',
    SOCIAL_TRANSFER_FIND_IDENTIFIER_RESULT = 'SOCIAL_TRANSFER_FIND_IDENTIFIER_RESULT',
    SOCIAL_TRANSFER_SELECT_RESULT = 'SOCIAL_TRANSFER_SELECT_RESULT'
  }
}
